import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalMeetingsService } from "services/ClientPortalMeetingsService";
import { ClientPortalMeetingModel, ClientPortalMeetingsFilterModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type MeetingsTableProps = {
  Meetings: ClientPortalMeetingModel[];
  LoadingMeetings: boolean;
};

const initialState: MeetingsTableProps = {
  Meetings: new Array<ClientPortalMeetingModel>(),
  LoadingMeetings: false,
};

export const MeetingsTableSlice = createSlice({
  name: "Meetings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMeetings.pending, (state) => {
        state.LoadingMeetings = true;
      })
      .addCase(getMeetings.fulfilled, (state, action) => {
        state.Meetings = action.payload;
        state.LoadingMeetings = false;
      })
      .addCase(getMeetings.rejected, (state) => {
        state.Meetings = new Array<ClientPortalMeetingModel>();
        state.LoadingMeetings = false;
      });
  },
});

export const getMeetings = createAsyncThunk<ClientPortalMeetingModel[], ClientPortalMeetingsFilterModel>(
  "Meetings/GetMeetings",
  async (filterModel: ClientPortalMeetingsFilterModel) => {
    const meetingsService = container.get<IClientPortalMeetingsService>(SERVICE_TYPES.CPLClientPortalMeetingsService);
    return await meetingsService.getMeetings(filterModel);
  }
);

export const selectMeetings = (state: RootState) => state.meetingsTable.Meetings;
export const selectLoadingMeetings = (state: RootState) => state.meetingsTable.LoadingMeetings;

export default MeetingsTableSlice.reducer;
